module.exports = __webpack_public_path__ + "images/emoji/fireworks.26792c88d79b938d15ae.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fireworks.png
// module id = JBjw
// module chunks = 14